import { render, staticRenderFns } from "./LoggerLink.vue?vue&type=template&id=f5dd5800"
import script from "./LoggerLink.vue?vue&type=script&lang=js"
export * from "./LoggerLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports